import { useEffect, useState } from "react";
import Modal from "../../../../components/base/Modal";
import { toastSuccess } from "../../../../components/base/Toast";
import DropDown from "../../../../components/form/DropDown";
import TextBox from "../../../../components/form/TextBox";
import Tagify from "../../../../components/tagify/Tagify";
import { API_ROUTES } from "../../../../core/Constants";
import { getUser, useHub, useJobTypes } from "../../../../core/Global";
import DataItem from "../../../../models/DataItem";
import TextArea from "../../../../components/form/TextArea";
import DatePicker from "../../../../components/form/DatePicker";
import WeekdaysPicker from "../../../../components/form/WeekdaysPicker";
import { DayOfWeek, RateCategories } from "../../../../core/Enums";
import { DrawerForm } from "../../../../components/drawers/DrawerForm";
import PhoneInput from "../../../../components/form/PhoneInput";
import TimePicker from "../../../../components/form/TimePicker";
import { RedirectCallsDateTypes, RedirectCallsItem, RedirectCallsRepeatTypes, RedirectRuleRequestModel } from "../models/RedirectRuleModels";

interface IProps {
    model?: RedirectCallsItem
    onClose?: () => void
    onSave?: () => void
}
export default function RedirectRuleForm(props: IProps) {

    const hub = useHub()
    const user = getUser()

    const [body, bodySet] = useState<RedirectRuleRequestModel>({})

    const [DateTypes] = useState<DataItem[]>([
        {
            id: "1",
            name: "Date Range"
        },
        {
            id: "2",
            name: "Weekdays"
        }
    ])

    const [WeekDays] = useState<DataItem[]>([
        {
            id: "1",
            name: "Monday"
        },
        {
            id: "2",
            name: "Tuesday"
        },
        {
            id: "3",
            name: "Wednesday"
        },
        {
            id: "4",
            name: "Thursday"
        },
        {
            id: "5",
            name: "Friday"
        },
        {
            id: "6",
            name: "Saturday"
        },
        {
            id: "0",
            name: "Sunday"
        }
    ])

    const [DateRepeatTypes] = useState<DataItem[]>([
        {
            id: "1",
            name: "Don't Repeat"
        },
        {
            id: "2",
            name: "Every Month"
        },
        {
            id: "3",
            name: "Every Year"
        }
    ])

    const [WeekdaysRepeatTypes] = useState<DataItem[]>([
        {
            id: "4",
            name: "Repeat Forever"
        },
        {
            id: "5",
            name: "Till Specific Date"
        }
    ])

    const [techsConfirmed, techsConfirmedSet] = useState<boolean>();


    useEffect(() => {
        if (props.model?.id) {

            const item = props.model

            bodySet({
                id: item.id,
                dateType: item.dateType,
                description: item.description,
                name: item.name,
                phone: item.phone,
                timezoneId: item.timezoneId,
                weekDayFrom: item.weekDayFrom,
                weekDayFromTime: item.weekDayFromTimeStr,
                weekDayTo: item.weekDayTo,
                weekDayToTime: item.weekDayToTimeStr,
                repeatType: item.repeatType,
                rangeDateFrom: item.rangeDates?.fromText,
                rangeDateTo: item.rangeDates?.toText,
                repeatTill: item.repeatTillText
            })

        }
        else if (user) {
            bodySet({
                timezoneId: user.timeZoneId
            })
        }
    }, [props.model, user])

    useEffect(() => {
        if (techsConfirmed) {
            window.closeModal("modal-confirm-redurectrules");
            $("#drawer-redirectrule-form-submit").click();
            techsConfirmedSet(false);
        }
    }, [techsConfirmed])

    const DrawerCreateTitle = () => {
        if (props.model) return "Update Rule";
        var txt = "Create Rule";
        return txt;
    }

    const DrawerButtonTitle = () => {
        if (props.model) return "Update Rule";
        var txt = "Create Rule";
        return txt;
    }

    return (
        <>
            <DrawerForm id="drawer-redirectrule-form" permanent size="large"
                title={DrawerCreateTitle()}
                buttonText={DrawerButtonTitle()}
                onOpen={() => {
                    $("#txt-rule-name").focus();
                }}
                onClose={props.onClose}
                onSubmit={(b, callback) => {

                    var valid = true;

                    // if (!body.name || body.name == "" || body.name.length < 2) {
                    //     window.showFormError("name", "Please write a valid name!", false, "drawer-redirectrule-form");
                    //     valid = false;
                    // }

                    // if (selectedDateType?.id == "specific" && window.isNullOrEmpty(body.specificDate0)) {
                    //     window.formError("dateType", "Please add date(s)!", "drawer-redirectrule-form");
                    //     valid = false;
                    // }

                    // if (selectedDateType?.id == "range" && window.isNullOrEmpty(body.rangeDateStart0) && window.isNullOrEmpty(body.rangeDateEnd0)) {
                    //     window.formError("dateType", "Please add date(s)!", "drawer-redirectrule-form");
                    //     valid = false;
                    // }

                    // if (selectedDateType?.id == "weekdays" && window.isNullOrEmpty(body.rateWeekdays)) {
                    //     window.formError("dateType", "Please select day(s)!", "drawer-redirectrule-form");
                    //     valid = false;
                    // }

                    // if (window.isNullOrEmpty(body.dateType) && window.isNullOrEmpty(body.techgroupIds) && window.isNullOrEmpty(body.techIds)
                    //     && window.isNullOrEmpty(body.shiftIds) && window.isNullOrEmpty(body.metroIds)
                    //     && window.isNullOrEmpty(body.sourceIds) && window.isNullOrEmpty(body.typeIds) && window.isNullOrEmpty(body.jobAmount)) {
                    //     valid = false;
                    // }




                    // if (!valid) {
                    //     if (callback) callback();
                    //     return;
                    // }


                    hub.Post(API_ROUTES.RedirectRules, {
                        ...body,
                        id: body.id
                    }, res => {
                        if (res.success) {
                            if (res.confirmRequired) {

                                if (callback) callback();
                                return;
                            }
                            else {
                                toastSuccess("Rule has been saved successfully!");
                                if (props.onSave) props.onSave();
                            }

                        }
                        if (callback) callback(res);
                    })



                }}>
                <div className="mb-10">

                    <TextBox id="txt-rule-name" name="name" label="Name *"
                        labelUp block marginBottom={5} value={body.name}
                        onTextChanges={val => bodySet({
                            ...body,
                            name: val
                        })} />

                    <TextArea name="descr" label="Description"
                        labelUp block marginBottom={5} value={body.description}
                        onChange={e => bodySet({
                            ...body,
                            description: e.target.value
                        })} />


                    <PhoneInput id="phone-redirectrule" name="phone" label="Redirect To" labelUp block
                        countryCodes="us-only" defaultPhone={body.phone}
                        onComplete={ph => bodySet({
                            ...body,
                            phone: ph
                        })}
                        onInComplete={() => bodySet({
                            ...body,
                            phone: undefined
                        })} />

                    <DropDown id="drp-redurectrules-timezones" name="timezone" label="Timezone" labelUp block deselect={false}
                        apiSource={API_ROUTES.Users + "timezones"} forceSelectValue={body.timezoneId}
                        onSelect={val => {
                            bodySet({
                                ...body,
                                timezoneId: val
                            })
                        }} />

                    <DropDown id="drp-redurectrules-datetypes" name="dateType" label="Date Type" labelUp block marginBottom={5}
                        source={DateTypes} dataValue="id" dataText="name" parentModal="drawer-redirectrule-form"
                        forceSelectValue={body.dateType?.toString()} deselect={false}
                        onSelectItem={item => {
                            bodySet({
                                ...body,
                                dateType: Number(item.id) as RedirectCallsDateTypes
                            })
                        }} />


                    {
                        body.dateType == RedirectCallsDateTypes.DateRange &&
                        <DatePicker id="dt-redurectrules-daterange" key={"dt-redurectrules-daterange"}
                            name="rangeDate" marginBottom={5} icon="calendar"
                            dateType="range" timePicker
                            drops="up" label="Date Range" labelUp block
                            selectedDate={(body.id ? (body.rangeDateFrom + "-" + body.rangeDateTo) : undefined)}
                            onPick={r => {
                                bodySet({
                                    ...body,
                                    rangeDateFrom: r.startVal,
                                    rangeDateTo: r.endVal
                                })
                            }} />
                    }

                    {
                        body.dateType == RedirectCallsDateTypes.WeekDays &&
                        <>
                            <div className="row">
                                <div className="col-6">
                                    <DropDown id="drp-redurectrules-weekdays-from" key={"drp-redurectrules-weekdays-from"}
                                        name="weekDayFrom" label="From" labelUp block marginBottom={5}
                                        source={WeekDays} dataValue="id" dataText="name"
                                        forceSelectValue={body.weekDayFrom?.toString()}
                                        onSelectItem={item => {
                                            bodySet({
                                                ...body,
                                                weekDayFrom: Number(item.id)
                                            })
                                        }} />
                                </div>
                                <div className="col-6">
                                    <TimePicker id="drp-redurectrules-weekdays-fromtime"
                                        key={"drp-redurectrules-weekdays-fromtime"}
                                        name="weekDayFromTime" label="Time" labelUp block
                                        defaultValue={body.weekDayFromTime}
                                        onTimePicked={t => {
                                            bodySet({
                                                ...body,
                                                weekDayFromTime: t.label
                                            })
                                        }} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <DropDown id="drp-redurectrules-weekdays-to" key={"drp-redurectrules-weekdays-to"}
                                        name="weekDayTo" label="To" labelUp block marginBottom={5}
                                        source={WeekDays} dataValue="id" dataText="name"
                                        forceSelectValue={body.weekDayTo?.toString()}
                                        onSelectItem={item => {
                                            bodySet({
                                                ...body,
                                                weekDayTo: Number(item.id)
                                            })
                                        }} />
                                </div>
                                <div className="col-6">
                                    <TimePicker id="drp-redurectrules-weekdays-totime"
                                        key={"drp-redurectrules-weekdays-totime"}
                                        name="weekDayToTime" label="Time" labelUp block
                                        defaultValue={body.weekDayToTime}
                                        onTimePicked={t => {
                                            bodySet({
                                                ...body,
                                                weekDayToTime: t.label
                                            })
                                        }} />
                                </div>
                            </div>
                        </>
                    }

                    {
                        body.dateType &&
                        <DropDown id="drp-redurectrules-repeats" name="repeatType" label="Repeat Type" labelUp block marginBottom={5} autoSelectFirstItem={(!props.model)}
                            source={body.dateType == RedirectCallsDateTypes.WeekDays ? WeekdaysRepeatTypes : DateRepeatTypes} dataValue="id" dataText="name" parentModal="drawer-redirectrule-form"
                            defaultValue={props.model?.repeatType?.toString()} deselect={false}
                            forceSelectValue={body.repeatType?.toString()}
                            onSelectItem={item => {
                                bodySet({
                                    ...body,
                                    repeatType: Number(item.id) as RedirectCallsRepeatTypes
                                })
                            }} />
                    }

                    {
                        body.repeatType == RedirectCallsRepeatTypes.SpecificDate &&
                        <DatePicker id="dt-redurectrules-repeattill" name="repeatTill" marginBottom={5} dateType="single"
                            label="Repeat Till" labelUp block drops="up" icon="calendar"
                            selectedDate={body.repeatTill} timePicker
                            onPick={d => {
                                bodySet({
                                    ...body,
                                    repeatTill: d.value
                                })
                            }} />
                    }



                    {/* <Tagify id="tagify-redurectrules-extensions" key={"tagify-redurectrules-extensions"}
                        name="metroIds" apiUrl={API_ROUTES.TagifyExtensions} marginBottom={5}
                        label="Extension(s)" labelUp block placeholder="Select Extension(s)" selectedIds={props.model?.metroIds} />

                    <Tagify id="tagify-redurectrules-queueus" key={"tagify-redurectrules-queueus"}
                        name="typeIds" apiUrl={API_ROUTES.TagifyQueues} marginBottom={10}
                        label="Queue(s)" labelUp block placeholder="Select Queue(s)" selectedIds={props.model?.jobTypeIds} /> */}

                </div>
            </DrawerForm>
        </>
    )
}